import { Col, Layout, Row, Table, Tabs, Tooltip, Typography, Space, Badge } from "antd";
import { showError } from "common/ToastNotifications";
import { AggregationsCount, FullHeightContainerLayout } from "components";
import { CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined, SyncOutlined, InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const { TabPane } = Tabs;
const { Header, Content, Footer, Sider } = Layout;
const { Title } = Typography;
const { Column, ColumnGroup } = Table;

class DomainServiceConsole extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            runningJobs: [
                {
                    job: "6fea8f44a782433783a654c694dfe24a",
                    started: "01/01/2020 00:00:00",
                    runningFor: "1h50m",
                },
                {
                    job: "02e9f00c7c864582b3992ec79b3b523a",
                    started: "01/01/2020 00:00:00",
                    runningFor: "1h50m",
                },
                {
                    job: "8eab6228c50640f3ae9ea8eeb0bbbff6",
                    started: "01/01/2020 00:00:00",
                    runningFor: "1h50m",
                },
            ],
            failedJobs: [
                {
                    job: "6fea8f44a782433783a654c694dfe24a",
                    started: "01/01/2020 00:00:00",
                    ended: "01/01/2020 01:00:00",
                },
                {
                    job: "02e9f00c7c864582b3992ec79b3b523a",
                    started: "01/01/2020 00:00:00",
                    ended: "01/01/2020 01:00:00",
                },
                {
                    job: "8eab6228c50640f3ae9ea8eeb0bbbff6",
                    started: "01/01/2020 00:00:00",
                    ended: "01/01/2020 01:00:00",
                },
            ],
        };
    }

    componentDidMount() {
        this.props.getRecentLoggedInUsers();
        this.props.getAggregations();
        this.props.getRunningJobs();
        this.props.getFailedJobs();
        if (!this.props.aggregations) {
            this.setState({
                fetchingAggregates: true,
            });
        }
        if (!this.props.recentLoggedInUsersResult || this.props.recentLoggedInUsersResult.Items.length === 0) {
            this.setState({
                fetchingRecentLoggedInUsers: true,
            });
        }
        if (!this.props.runningJobsResult || this.props.runningJobsResult.Items.length === 0) {
            this.setState({
                fetchingRunningJobs: true,
            });
        }
        if (!this.props.failedJobsResult || this.props.failedJobsResult.Items.length === 0) {
            this.setState({
                fetchingFailedJobs: true,
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetAggregationsResultChanged(prevProps);
        this.onGetRecentLoggedInUsersResultChanged(prevProps);
        this.onGetRunningJobsResultChanged(prevProps);
        this.onGetFailedJobsResultChanged(prevProps);
    }

    onGetAggregationsResultChanged = (prevProps) => {
        if (this.props.getAggregationsResult && this.props.getAggregationsResult !== prevProps.getAggregationsResult) {
            if (!this.props.getAggregationsResult.success) {
                showError("Unable to get counts.");
            }
            this.setState({
                fetchingAggregates: false,
            });
        }
    };

    onGetRecentLoggedInUsersResultChanged = (prevProps) => {
        if (this.props.getRecentLoggedInUsersResult && this.props.getRecentLoggedInUsersResult !== prevProps.getRecentLoggedInUsersResult) {
            if (!this.props.getRecentLoggedInUsersResult.success) {
                showError("Unable to get recent logged-in users.");
            }
            this.setState({
                fetchingRecentLoggedInUsers: false,
            });
        }
    };

    onGetRunningJobsResultChanged = (prevProps) => {
        if (this.props.getRunningJobsResult && this.props.getRunningJobsResult !== prevProps.getRunningJobsResult) {
            if (!this.props.getRunningJobsResult.success) {
                showError("Unable to get running jobs.");
            }
            this.setState({
                fetchingRunningJobs: false,
            });
        }
    };

    onGetFailedJobsResultChanged = (prevProps) => {
        if (this.props.getFailedJobsResult && this.props.getFailedJobsResult !== prevProps.getFailedJobsResult) {
            if (!this.props.getFailedJobsResult.success) {
                showError("Unable to get failed jobs.");
            }
            this.setState({
                fetchingFailedJobs: false,
            });
        }
    };

    getSyncStatusInfo = () => {
        const { aggregations } = this.props;
        if (!aggregations || !aggregations.lastSynced) {
            const nextSyncMomentUtc = moment.utc().startOf('day').add(3, 'hours');
            if (moment.utc().isAfter(nextSyncMomentUtc)) {
                nextSyncMomentUtc.add(1, 'day');
            }

            return { 
                icon: <ClockCircleOutlined style={{ fontSize: 16 }} />, 
                status: 'Pending First Sync', 
                detail: 'Reconciliation has not run yet',
                schedule: 'Runs daily at 3:00 AM UTC',
                nextSync: nextSyncMomentUtc.fromNow(),
                nextSyncLocal: nextSyncMomentUtc.local().format('MMM DD, YYYY h:mm A'),
                color: '#faad14',
                timestamp: null,
                displayTime: null,
                primaryText: 'No reconciliation yet',
                secondaryText: 'Waiting for the first scheduled run',
                badgeStatus: 'warning',
                discrepancies: 0,
                correctedCounters: []
            };
        }

        const lastSyncedDate = moment.utc(aggregations.lastSynced).local();
        const timeAgo = lastSyncedDate.fromNow();
        const nextSyncMomentUtc = moment.utc().startOf('day').add(3, 'hours');
        if (moment.utc().isAfter(nextSyncMomentUtc)) {
            nextSyncMomentUtc.add(1, 'day');
        }
        const nextSync = nextSyncMomentUtc.fromNow();
        const correctedCounters = aggregations.lastSyncCorrectedCounters || [];
        const discrepancies = aggregations.lastSyncDiscrepancies || 0;
        const timestamp = lastSyncedDate.format('MMM DD, YYYY h:mm:ss A');
        const displayTime = lastSyncedDate.format('MMM DD, h:mm A');

        switch (aggregations.lastSyncStatus) {
            case 'COMPLETED':
                return {
                    icon: <CheckCircleOutlined style={{ fontSize: 16 }} />,
                    status: `Synced ${timeAgo}`,
                    detail: discrepancies > 0 
                        ? `${discrepancies} counter${discrepancies > 1 ? 's' : ''} corrected`
                        : 'All data accurate',
                    schedule: 'Runs daily at 3:00 AM UTC',
                    nextSync,
                    nextSyncLocal: nextSyncMomentUtc.local().format('MMM DD, YYYY h:mm A'),
                    color: '#52c41a',
                    timestamp,
                    displayTime,
                    primaryText: `Last reconciled ${timeAgo}`,
                    secondaryText: `at ${displayTime} (local time)`,
                    badgeStatus: discrepancies > 0 ? 'warning' : 'success',
                    discrepancies,
                    correctedCounters
                };
            case 'NO_DISCREPANCIES':
                return {
                    icon: <CheckCircleOutlined style={{ fontSize: 16 }} />,
                    status: `Verified ${timeAgo}`,
                    detail: 'All counters accurate',
                    schedule: 'Runs daily at 3:00 AM UTC',
                    nextSync,
                    nextSyncLocal: nextSyncMomentUtc.local().format('MMM DD, YYYY h:mm A'),
                    color: '#52c41a',
                    timestamp,
                    displayTime,
                    primaryText: `Last reconciled ${timeAgo}`,
                    secondaryText: `at ${displayTime} (local time)`,
                    badgeStatus: 'success',
                    discrepancies: 0,
                    correctedCounters: []
                };
            case 'FAILED':
                return {
                    icon: <CloseCircleOutlined style={{ fontSize: 16 }} />,
                    status: `Sync Failed ${timeAgo}`,
                    detail: 'Please check logs',
                    schedule: 'Runs daily at 3:00 AM UTC',
                    nextSync,
                    nextSyncLocal: nextSyncMomentUtc.local().format('MMM DD, YYYY h:mm A'),
                    color: '#ff4d4f',
                    timestamp,
                    displayTime,
                    primaryText: `Last attempt ${timeAgo}`,
                    secondaryText: `at ${displayTime} (local time)`,
                    badgeStatus: 'error',
                    discrepancies: 0,
                    correctedCounters: []
                };
            default:
                return { 
                    icon: <SyncOutlined spin style={{ fontSize: 16 }} />, 
                    status: 'Syncing...', 
                    detail: 'Data reconciliation in progress',
                    schedule: 'Runs daily at 3:00 AM UTC',
                    nextSync,
                    nextSyncLocal: nextSyncMomentUtc.local().format('MMM DD, YYYY h:mm A'),
                    color: '#1890ff',
                    timestamp,
                    displayTime,
                    primaryText: 'Reconciliation running',
                    secondaryText: timestamp ? `Started from ${displayTime} (local time)` : 'Updating counters now',
                    badgeStatus: 'processing',
                    discrepancies: 0,
                    correctedCounters: []
                };
        }
    };

    render() {
        const syncStatus = this.getSyncStatusInfo();
        
        return (
            <FullHeightContainerLayout
                showHeader={false}
                showFooter={false}
                content={
                    <Row style={{ width: "100%", height: "100%" }} wrap={false}>
                        <Col span={24} style={{ display: "flex", height: "100%", flexDirection: "column", rowGap: "10px" }}>
                            <Row justify="end" style={{ width: "100%" }}>
                                <Tooltip
                                    placement="bottomRight"
                                    title={
                                        <div style={{ padding: "4px" }}>
                                            <div style={{ 
                                                fontSize: "11px", 
                                                fontWeight: 600, 
                                                marginBottom: "8px",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.5px"
                                            }}>
                                                Aggregation Reconciliation
                                            </div>
                                            <div style={{ marginBottom: "6px" }}>
                                                <div style={{ fontSize: "13px", fontWeight: 500, marginBottom: "2px" }}>
                                                    {syncStatus.icon} {syncStatus.status}
                                                </div>
                                                <div style={{ fontSize: "11px", opacity: 0.85 }}>
                                                    {syncStatus.detail}
                                                </div>
                                            </div>
                                            {syncStatus.timestamp && (
                                                <div style={{ fontSize: "11px", opacity: 0.75, marginBottom: "6px" }}>
                                                    Last sync: {syncStatus.timestamp} (local time)
                                                </div>
                                            )}
                                            {syncStatus.correctedCounters && syncStatus.correctedCounters.length > 0 && (
                                                <div style={{ fontSize: "11px", opacity: 0.75, marginBottom: "6px" }}>
                                                    Corrected: {syncStatus.correctedCounters.join(', ')}
                                                </div>
                                            )}
                                            <div style={{ 
                                                borderTop: "1px solid rgba(255,255,255,0.2)", 
                                                paddingTop: "6px", 
                                                marginTop: "6px"
                                            }}>
                                                <div style={{ fontSize: "11px", opacity: 0.85 }}>
                                                    <ClockCircleOutlined /> {syncStatus.schedule}
                                                </div>
                                                {syncStatus.nextSync && (
                                                    <div style={{ fontSize: "11px", opacity: 0.75, marginTop: "2px" }}>
                                                        Next sync in {syncStatus.nextSync}
                                                    </div>
                                                )}
                                                {syncStatus.nextSyncLocal && (
                                                    <div style={{ fontSize: "11px", opacity: 0.75, marginTop: "2px" }}>
                                                        Next sync at {syncStatus.nextSyncLocal} (local time)
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    }
                                    overlayStyle={{ maxWidth: "420px" }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            columnGap: "10px",
                                            border: "1px solid #d9d9d9",
                                            borderRadius: "10px",
                                            background: "#fafafa",
                                            padding: "8px 10px",
                                            cursor: "pointer",
                                            maxWidth: "100%"
                                        }}
                                    >
                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", lineHeight: 1.2 }}>
                                            <span style={{ fontSize: "12px", color: "#262626", fontWeight: 600 }}>
                                                {syncStatus.primaryText}
                                            </span>
                                            <span style={{ fontSize: "11px", color: "#595959" }}>
                                                {syncStatus.secondaryText}
                                            </span>
                                        </div>
                                        <Space size={6} align="center">
                                            <Badge status={syncStatus.badgeStatus || "default"} dot>
                                                <InfoCircleOutlined style={{ fontSize: 18, color: syncStatus.color }} />
                                            </Badge>
                                        </Space>
                                    </div>
                                </Tooltip>
                            </Row>

                            <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", rowGap: "10px" }}>
                                <Row style={{ width: "100%", flex: 1, minHeight: 0 }} gutter={[40, 16]} wrap={false}>
                                    <AggregationsCount loading={this.state.fetchingAggregates} counts={this.props.aggregations}></AggregationsCount>
                                </Row>
                                <Row style={{ width: "100%", flex: 1, minHeight: 0 }} gutter={[40, 16]} wrap={false}>
                                    <Col span={8} style={{ height: "100%" }}>
                                    <FullHeightContainerLayout
                                        content={
                                            <div className="full-height-flex-container verticle-scroll" style={{ padding: "unset" }}>
                                                <div className="full-height-flex-container">
                                                    <Table
                                                        size="small"
                                                        dataSource={this.props.recentLoggedInUsersResult.Items}
                                                        loading={this.state.fetchingRecentLoggedInUsers}
                                                        pagination={false}
                                                        scroll={{ y: `100vh` }}
                                                        className="container-height-80 domain-service-console-table"
                                                    >
                                                        <ColumnGroup title="Current Users Logged On">
                                                            <Column
                                                                title="User"
                                                                dataIndex="email"
                                                                key="email"
                                                                ellipsis={{
                                                                    showTitle: false,
                                                                }}
                                                                render={(value, data, index) => (
                                                                    <Tooltip placement="topLeft" title={value}>
                                                                        {value}
                                                                    </Tooltip>
                                                                )}
                                                            />
                                                            <Column
                                                                title="Last Login"
                                                                dataIndex="lastLoginAt"
                                                                key="lastLoginAt"
                                                                ellipsis={{
                                                                    showTitle: false,
                                                                }}
                                                                render={(value, job, index) => {
                                                                    let displayValue = null;
                                                                    if (value) {
                                                                        displayValue = moment.utc(value).local().format('MMM DD, YYYY h:mm A');
                                                                        return (
                                                                            <Tooltip placement="topLeft" title={displayValue}>
                                                                                {displayValue}
                                                                            </Tooltip>
                                                                        );
                                                                    }
                                                                    return <></>;
                                                                }}
                                                            />
                                                        </ColumnGroup>
                                                    </Table>
                                                </div>
                                            </div>
                                        }
                                    ></FullHeightContainerLayout>
                                    </Col>
                                    <Col span={8} style={{ height: "100%" }}>
                                    <FullHeightContainerLayout
                                        content={
                                            <div className="full-height-flex-container verticle-scroll" style={{ padding: "unset" }}>
                                                <div className="full-height-flex-container">
                                                    <Table
                                                        size="small"
                                                        loading={this.state.fetchingRunningJobs}
                                                        dataSource={this.props.runningJobsResult.Items}
                                                        pagination={false}
                                                        scroll={{ y: `100vh` }}
                                                        className="container-height-80 domain-service-console-table"
                                                    >
                                                        <ColumnGroup title="Running Jobs">
                                                            <Column
                                                                title="Job"
                                                                dataIndex="jobId"
                                                                key="jobId"
                                                                ellipsis={{
                                                                    showTitle: false,
                                                                }}
                                                                render={(value, data, index) => (
                                                                    <Tooltip placement="topLeft" title={value}>
                                                                        {value}
                                                                    </Tooltip>
                                                                )}
                                                            />
                                                            <Column
                                                                title="Started"
                                                                dataIndex="startedDate"
                                                                key="startedDate"
                                                                ellipsis={{
                                                                    showTitle: false,
                                                                }}
                                                                render={(value, job, index) => {
                                                                    if (value) {
                                                                        let displayValue = moment.utc(value).local().format('MMM DD, YYYY h:mm A');
                                                                        return (
                                                                            <Tooltip placement="topLeft" title={displayValue}>
                                                                                {displayValue}
                                                                            </Tooltip>
                                                                        );
                                                                    }
                                                                    return <></>;
                                                                }}
                                                            />
                                                            <Column
                                                                title="Running for"
                                                                dataIndex="startedDate"
                                                                key="runningFor"
                                                                ellipsis={{
                                                                    showTitle: false,
                                                                }}
                                                                render={(value, job, index) => {
                                                                    if (job.startedDate) {
                                                                        let startDate = moment.utc(value).local();
                                                                        let currentDate = moment();
                                                                        let duration = moment.duration(currentDate.diff(startDate));
                                                                        let displayValue = moment.utc(duration.as("milliseconds")).format("HH:mm:ss");
                                                                        return (
                                                                            <Tooltip placement="topLeft" title={displayValue}>
                                                                                {displayValue}
                                                                            </Tooltip>
                                                                        );
                                                                    }
                                                                    return <></>;
                                                                }}
                                                            />
                                                        </ColumnGroup>
                                                    </Table>
                                                </div>
                                            </div>
                                        }
                                    ></FullHeightContainerLayout>
                                    </Col>
                                    <Col span={8} style={{ height: "100%" }}>
                                    <FullHeightContainerLayout
                                        content={
                                            <div className="full-height-flex-container verticle-scroll" style={{ padding: "unset" }}>
                                                <div className="full-height-flex-container">
                                                    <Table
                                                        size="small"
                                                        loading={this.state.fetchingFailedJobs}
                                                        dataSource={this.props.failedJobsResult.Items}
                                                        pagination={false}
                                                        scroll={{ y: `100vh` }}
                                                        className="container-height-80 domain-service-console-table"
                                                    >
                                                        <ColumnGroup title="Failed Jobs">
                                                            <Column
                                                                title="Job"
                                                                dataIndex="jobId"
                                                                key="jobId"
                                                                ellipsis={{
                                                                    showTitle: false,
                                                                }}
                                                                render={(value, data, index) => (
                                                                    <Tooltip placement="topLeft" title={value}>
                                                                        {value}
                                                                    </Tooltip>
                                                                )}
                                                            />
                                                            <Column
                                                                title="Started"
                                                                dataIndex="startedDate"
                                                                key="startedDate"
                                                                ellipsis={{
                                                                    showTitle: false,
                                                                }}
                                                                render={(value, job, index) => {
                                                                    if (value) {
                                                                        let displayValue = moment.utc(value).local().format('MMM DD, YYYY h:mm A');
                                                                        return (
                                                                            <Tooltip placement="topLeft" title={displayValue}>
                                                                                {displayValue}
                                                                            </Tooltip>
                                                                        );
                                                                    }
                                                                    return <></>;
                                                                }}
                                                            />
                                                            <Column
                                                                title="Ended"
                                                                dataIndex="completedDate"
                                                                key="ended"
                                                                ellipsis={{
                                                                    showTitle: false,
                                                                }}
                                                                render={(value, job, index) => {
                                                                    if (value) {
                                                                        let displayValue = moment.utc(value).local().format('MMM DD, YYYY h:mm A');
                                                                        return (
                                                                            <Tooltip placement="topLeft" title={displayValue}>
                                                                                {displayValue}
                                                                            </Tooltip>
                                                                        );
                                                                    }
                                                                    return <></>;
                                                                }}
                                                            />
                                                        </ColumnGroup>
                                                    </Table>
                                                </div>
                                            </div>
                                        }
                                    ></FullHeightContainerLayout>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                }
            ></FullHeightContainerLayout>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getAggregationsResult: state.domainServiceConsole.getAggregationsResult,
        aggregations: state.domainServiceConsole.aggregations,
        getRecentLoggedInUsersResult: state.domainServiceConsole.getRecentLoggedInUsersResult,
        recentLoggedInUsersResult: state.domainServiceConsole.recentLoggedInUsersResult,
        getRunningJobsResult: state.domainServiceConsole.getRunningJobsResult,
        runningJobsResult: state.domainServiceConsole.runningJobsResult,
        getFailedJobsResult: state.domainServiceConsole.getFailedJobsResult,
        failedJobsResult: state.domainServiceConsole.failedJobsResult,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAggregations: () => dispatch(actions.getAggregationsRequest()),
        getRecentLoggedInUsers: () => dispatch(actions.getRecentLoggedInUsersRequest()),
        getRunningJobs: () => dispatch(actions.getRunningJobsRequest()),
        getFailedJobs: () => dispatch(actions.getFailedJobsRequest()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DomainServiceConsole));
